import { useParams } from 'react-router';

export const usePeoParamId = () => {
  const { peoId } = useParams<{ peoId: string }>();
  return peoId;
};
